import React, { useRef, useEffect, useState, useMemo } from 'react';
import MP4VideoPlayer from './Mp4VideoPlayer';
import { Box, Tooltip, Typography } from '@mui/material';
import { API_ENDPOINTS } from 'packages/novous_web/src/api/endpoints';
import useAxios from 'packages/novous_web/src/api/useAxios';
import AlertToast from 'packages/novous_web/src/common/components/Alert';
import VideoPlayer from './VideoPlayer';
// UI actions (upload/download/refresh) and network subscription are handled by parent (e.g., TrVod)

type Segment = {
  startTime: string;
  endTime: string;
  status: 'AVAILABLE' | 'AVAILABLE_LOADED' | 'UNAVAILABLE';
};
type AlertItem = {
  startTime: string;
  endTime: string;
  status: string;
  cameraType?: string;
};

type AlertData = {
  data: {
    [key: string]: AlertItem[];
  };
};


type PlayBackPlayerProps = {
  alertData: AlertData;
  deviceId: string;
  cameraId: any;
  handleCurrentVideoData: (data: any) => void;
  channelKey?: string;
  refreshKey?: number;
};

export const PlayBackPlayer: React.FC<PlayBackPlayerProps> = ({ alertData, handleCurrentVideoData, channelKey, deviceId, cameraId, refreshKey }) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const [segments, setSegments] = useState<AlertItem[]>([]);
  const [streamUrl, setStreamUrl] = useState({ isUrl: false, value: '' });
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const [toast, setToast] = useState({ open: false, message: '', type: 'error' });
  const [selectedSegment, setSelectedSegment] = useState<any>(null);
  const {
    data: SingleVideoDataData,
    error: SingleVideoDataError,
    loading: SingleVideoDataLoading,
    fetchData: fetchSingleVideoDataData,
  } = useAxios<any>(`${API_ENDPOINTS.sdCard.GET_FOOTAGE_URL}`, "POST");
  console.log(alertData, 'alertData xx final');

  // Update segments when alertData or channelKey changes
  useEffect(() => {
    const keys = Object.keys(alertData.data);
    setStreamUrl({ isUrl: false, value: '' }); // Reset stream URL when alertData changes
    const key = channelKey && keys.includes(channelKey) ? channelKey : keys[0];
    setSegments(alertData.data[key] || []);
    setCooldown(false);
    setCooldownTime(0);
    setSelectedSegment(null);
  }, [alertData, channelKey]);

  useEffect(() => {
    if (SingleVideoDataError) {
      setToast({ open: true, message: 'Failed to fetch video clip', type: 'error' });
      setCooldown(false);
      setCooldownTime(0);
      setSelectedSegment(null);
    }
  }, [SingleVideoDataError])

  // Dynamically measure container size
  useEffect(() => {
    const updateSize = () => {
      if (containerRef.current) {
        setDimensions({
          width: containerRef.current.offsetWidth,
          height: containerRef.current.offsetHeight - 65,
        });
      }
    };
    updateSize();
    window.addEventListener('resize', updateSize);
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  useEffect(() => {
    if (SingleVideoDataData) {
      if (SingleVideoDataData?.data) {
        setStreamUrl({ isUrl: true, value: SingleVideoDataData.data });
      } else {
        // No valid data returned, show error and prevent cooldown
        setToast({ open: true, message: 'Stream URL is empty. Please try again.', type: 'error' });
        setCooldown(false);
        setCooldownTime(0);
        setSelectedSegment(null);
      }
    }
  }, [SingleVideoDataData])

  // Calculate timing values
  const { baseMs, durationSec, timedSegments } = useMemo(() => {
    if (!segments.length) return { baseMs: 0, durationSec: 0, timedSegments: [] as any[] };

    const segmentCount = segments.length;
    const segmentWidthPct = 100 / segmentCount;

    const timed = segments.map((seg, index) => {
      return {
        ...seg,
        startSec: index, // purely sequential position if needed
        endSec: index + 1,
        startPct: index * segmentWidthPct,
        widthPct: segmentWidthPct,
      };
    });

    return { baseMs: 0, durationSec: segmentCount, timedSegments: timed };
  }, [segments]);


  function extractDateAndTime(datetime: any) {
    if (!datetime || !datetime.includes(':')) return { date: '', time: '' };

    const [date, time] = datetime.split(':', 2);
    const timePart = datetime.slice(date.length + 1); // get everything after the first colon

    return {
      date,
      time: timePart
    };
  }

  // Example usage:
  const input = "2025-05-06:11:05:02";
  const result = extractDateAndTime(input);
  console.log(result);
  // { date: '2025-05-06', time: '11:05:02' }



  const extractTimeFromDateTime = (datetime: string): string => {
    if (!datetime || datetime.length < 19) return '';

    // Ensure there's a colon at position 10
    if (datetime[10] !== ':') return '';

    // Extract time part after the colon
    return datetime.slice(11);
  };

  const [cooldown, setCooldown] = useState(false);
  const [cooldownTime, setCooldownTime] = useState(0);



  useEffect(() => {
    setSelectedSegment(null);
  }, [refreshKey]);

  const onSegmentSelect = (segment: any) => {
    setSelectedSegment(segment);
    handleCurrentVideoData(segment);
  };
  console.log(streamUrl.value, 'streamUrl.value');
  return (
    <>
      <div className='flex h-full gap-2 flex-col' ref={containerRef}>

        {streamUrl.isUrl && streamUrl.value.split('?')[0].toLowerCase().endsWith('.mp4') ? (
          // <video
          //   key={streamUrl.value} // to force reload on URL change
          //   src={streamUrl.value}
          //   controls
          //   autoPlay
          //   muted
          //   style={{
          //     width: dimensions.width,
          //     height: dimensions.height,
          //     backgroundColor: 'black',
          //     objectFit: 'contain',
          //     borderRadius: '8px',
          //   }}
          // >
          //   Your browser does not support the video tag.
          // </video>
          // <video
          //   key={streamUrl.value}
          //   src={streamUrl.value}
          //   controls={false}
          //   muted
          //   autoPlay
          //   style={{
          //     width: `${dimensions.width}px`,
          //     height: `${dimensions.height}px`,
          //     background: 'black',
          //     objectFit: 'contain',
          //     borderRadius: '8px',
          //   }}
          // >
          //   Your browser does not support the video tag.
          // </video>
          <MP4VideoPlayer
            availableHeight={dimensions.height}
            availableWidth={dimensions.width}
            // showVodLoading={true}
            streamUrl={streamUrl.isUrl && streamUrl.value}
            deviceId={deviceId}
            cameraId={cameraId[1]}
          />
        ) : (
          <VideoPlayer
            availableHeight={dimensions.height}
            availableWidth={dimensions.width}
            showVodLoading={true}
            streamUrl={streamUrl.isUrl ? streamUrl.value : ''}
            deviceId={deviceId}
            cameraId={cameraId[1]}
          />
        )}
        {
          SingleVideoDataLoading && (
            <div className='flex items-center justify-center'>
              <div className="loader">Stream Loading.....</div>
            </div>
          )
        }

        {/* Parent (e.g. TrVod) handles network and upload/download UI */}

        <div
          style={{
            position: 'relative',
            width: '100%',
            height: 8,
            background: '#ccc',
            borderRadius: 4,
            overflow: 'hidden',
            margin: '8px auto',
          }}
        >
          {timedSegments.map((seg, idx) => (
            <Tooltip
              key={idx}
              title={`${extractTimeFromDateTime(seg.startTime)} - ${extractTimeFromDateTime(seg.endTime)}`}
              arrow
              placement="top"
            >
              <div
                onClick={() => {
                  if (cooldown && seg.status !== 'UNAVAILABLE') {
                    setToast({ open: true, message: `Please wait ${cooldownTime} seconds`, type: 'error' });
                    return;
                  }
                  if (seg.status === 'UNAVAILABLE') {
                    setToast({ open: true, message: 'This video is not available in SD card', type: 'error' });
                    return;
                  }
                  if (seg.status === 'AVAILABLE_LOADED' || seg.status === 'AVAILABLE') {
                    setStreamUrl({ isUrl: false, value: '' });
                    fetchSingleVideoDataData({
                      startTime: seg.startTime,
                      endTime: seg.endTime,
                      deviceId,
                      cameraId: cameraId[1],
                    })
                    handleCurrentVideoData(seg)
                    setCooldown(true);
                    setCooldownTime(30);
                    setSelectedSegment(idx);
                    // videoRef.current.currentTime = seg.startSec;
                    // videoRef.current.play();
                    const timer = setInterval(() => {
                      setCooldownTime(prev => {
                        if (prev <= 1) {
                          clearInterval(timer);
                          setCooldown(false);
                          return 0;
                        }
                        return prev - 1;
                      });
                    }, 1000);
                  }
                }}
                style={{
                  position: 'absolute',
                  left: `${seg.startPct}%`,
                  width: `${seg.widthPct}%`,
                  height: '100%',
                  borderRight: idx !== timedSegments.length - 1 ? '1px solid white' : 'none',
                  background:
                    selectedSegment === idx
                      ? '#3F51B5'
                      : seg.status === 'AVAILABLE_LOADED'
                        ? 'green'
                        : seg.status === 'AVAILABLE'
                          ? 'yellow'
                          : 'red',
                  cursor: (seg.status === 'AVAILABLE_LOADED' || seg.status === 'AVAILABLE') && !cooldown ? 'pointer' : 'default',
                  opacity: cooldown ? 0.7 : 1,
                }}
              />
            </Tooltip>
          ))}
        </div>
        <DotLegend />
      </div>
      <AlertToast
        open={toast.open}
        message={toast.message}
        onClose={() => setToast((prev) => ({ ...prev, open: false }))}
        type={toast.type as any} />
    </>
  );
};

const DotLegend = () => {
  const items = [
    { color: 'green', label: 'Loaded' },
    { color: 'yellow', label: 'Available' },
    { color: 'red', label: 'Unavailable' },
    { color: '#3F51B5', label: 'Selected' },
  ];

  return (
    <Box display="flex" alignItems="center" justifyContent="end" gap={3}>
      {items.map((item, idx) => (
        <Box key={idx} display="flex" flexDirection="row" gap={1} alignItems="center">
          <Box
            sx={{
              width: 12,
              height: 12,
              borderRadius: '50%',
              backgroundColor: item.color,
              mb: 0.5,
            }}
          />
          <Typography variant="caption" color="textSecondary">
            {item.label}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};